<ng-container>
  <ng-container *ngIf="column.headerTemplate; else defaultCell">
    <ng-container
      [ngTemplateOutlet]="column.headerTemplate"
      [ngTemplateOutletContext]="{ value: column.title }"
    ></ng-container>
  </ng-container>
  <ng-template #defaultCell>
    {{ column.title }}
  </ng-template>
</ng-container>
